import { AudioLines, BarChart3, CreditCard, Headphones, LayoutDashboard, LayoutTemplate, LifeBuoy, Link2, ListMusic, Music4, ScrollText, Send, Settings, ShoppingBag, Sparkles, Users, X, Facebook } from "lucide-react";

export const NAV = [
  { id: "dashboard", label: "Панель", icon: LayoutDashboard },
  {
    id: "payments", label: "Замовлення", icon: ShoppingBag,
    children: [{ id: "telegram", label: "TG-замовлення", icon: Send }],
  },
  { id: "users", label: "Користувачі", icon: Users },
  { id: "packages", label: "Платежі", icon: CreditCard },
  {
    id: "overview", label: "Аналітика", icon: BarChart3,
    children: [
      { id: "usage", label: "Використання ШІ", icon: Sparkles },
      { id: "logs", label: "Логи", icon: ScrollText },
    ],
  },
  {
    id: "orders", label: "Пісні", icon: Music4,
    children: [
      { id: "generations", label: "Генерації", icon: AudioLines },
      { id: "listen", label: "Прослуховування", icon: Headphones },
      { id: "examples", label: "Приклади", icon: ListMusic },
    ],
  },
  { id: "templates", label: "Шаблони", icon: LayoutTemplate, soon: true },
  { id: "links", label: "Партнери", icon: Link2 },
  { id: "fb", label: "Facebook", icon: Facebook },
  { id: "broadcast", label: "Розсилка", icon: Send, soon: true },
  { id: "reviews", label: "Підтримка", icon: LifeBuoy },
  { id: "settings", label: "Налаштування", icon: Settings },
];

function NavItem({ item, tab, onNavigate, badge }) {
  const active = tab === item.id;
  return (
    <>
      <button
        data-testid={`admin-tab-${item.id}`}
        disabled={item.soon}
        onClick={() => !item.soon && onNavigate(item.id)}
        className={`adm-nav-item ${active ? "adm-nav-item-active" : ""} ${item.soon ? "opacity-40 cursor-not-allowed" : ""}`}
      >
        <item.icon size={18} strokeWidth={1.9} className="shrink-0" />
        <span className="truncate">{item.label}</span>
        {item.soon && <span className="ml-auto text-[9px] font-mono uppercase tracking-wider text-[#475569]">скоро</span>}
        {!item.soon && badge ? (
          <span className="ml-auto min-w-[20px] h-5 px-1.5 rounded-full bg-[#2498FF]/20 text-[#7CC5FF] text-[10px] font-bold grid place-items-center">{badge}</span>
        ) : null}
      </button>
      {item.children?.map((c) => (
        <button
          key={c.id}
          data-testid={`admin-tab-${c.id}`}
          onClick={() => onNavigate(c.id)}
          className={`adm-nav-item !h-[38px] !text-[13px] ${tab === c.id ? "adm-nav-item-active" : ""}`}
          style={{ paddingLeft: 36 }}
        >
          <c.icon size={15} strokeWidth={1.9} className="shrink-0" />
          <span className="truncate">{c.label}</span>
        </button>
      ))}
    </>
  );
}

export function Sidebar({ tab, onNavigate, badges = {}, className = "" }) {
  return (
    <div className={`adm-sidebar flex flex-col h-full ${className}`}>
      <div className="flex items-center gap-2.5 h-16 px-4 shrink-0">
        <span className="grid place-items-center w-9 h-9 rounded-xl adm-grad">
          <AudioLines size={18} className="text-white" />
        </span>
        <span className="font-display font-extrabold tracking-wide text-white">E-PISNYA</span>
      </div>
      <div className="flex-1 overflow-y-auto adm-scroll px-3 pb-3 space-y-0.5">
        {NAV.map((item) => (
          <NavItem key={item.id} item={item} tab={tab} onNavigate={onNavigate} badge={badges[item.id]} />
        ))}
      </div>
      <div className="p-3 shrink-0">
        <div className="adm-card rounded-2xl p-4 relative overflow-hidden">
          <span className="absolute -top-8 -right-10 w-28 h-28 rounded-full pointer-events-none"
            style={{ background: "radial-gradient(circle, rgba(124,77,255,0.28), transparent 65%)" }} />
          <span className="grid place-items-center w-10 h-10 rounded-xl adm-grad relative">
            <AudioLines size={18} className="text-white" />
          </span>
          <div className="mt-3 text-sm font-semibold text-white relative">E-PISNYA</div>
          <div className="text-[11px] text-[#94A3BD] mt-0.5 relative">Створюємо музику разом</div>
        </div>
      </div>
    </div>
  );
}

const MOBILE_MAIN = [
  { id: "dashboard", label: "Панель", icon: LayoutDashboard },
  { id: "payments", label: "Замовлення", icon: ShoppingBag },
  { id: "orders", label: "Пісні", icon: Music4 },
  { id: "users", label: "Користувачі", icon: Users },
];

export function MobileNav({ tab, onNavigate, onMore, moreActive }) {
  return (
    <nav className="adm-bottomnav fixed bottom-0 inset-x-0 z-[60] lg:hidden"
      style={{ paddingBottom: "env(safe-area-inset-bottom)" }}>
      <div className="h-[68px] grid grid-cols-5">
        {MOBILE_MAIN.map((it) => {
          const active = tab === it.id;
          return (
            <button key={it.id} data-testid={`admin-mobile-tab-${it.id}`} onClick={() => onNavigate(it.id)}
              className={`flex flex-col items-center justify-center gap-1 transition-colors ${active ? "text-[#2498FF]" : "text-[#64748B]"}`}>
              <it.icon size={20} strokeWidth={active ? 2.2 : 1.8} />
              <span className={`text-[10px] ${active ? "text-white font-semibold" : ""}`}>{it.label}</span>
            </button>
          );
        })}
        <button data-testid="admin-mobile-more" onClick={onMore}
          className={`flex flex-col items-center justify-center gap-1 transition-colors ${moreActive ? "text-[#2498FF]" : "text-[#64748B]"}`}>
          <span className="flex items-center gap-0.5">
            <span className="w-1 h-1 rounded-full bg-current" />
            <span className="w-1 h-1 rounded-full bg-current" />
            <span className="w-1 h-1 rounded-full bg-current" />
          </span>
          <span className={`text-[10px] ${moreActive ? "text-white font-semibold" : ""}`}>Ще</span>
        </button>
      </div>
    </nav>
  );
}

export function MoreSheet({ open, onClose, tab, onNavigate }) {
  if (!open) return null;
  return (
    <div className="fixed inset-0 z-[90] lg:hidden">
      <div className="absolute inset-0 bg-black/60 backdrop-blur-sm" onClick={onClose} />
      <div className="absolute inset-x-0 bottom-0 rounded-t-3xl adm-sidebar border-t border-white/10 p-4 pb-8 max-h-[78vh] overflow-y-auto adm-scroll"
        style={{ paddingBottom: "calc(1.5rem + env(safe-area-inset-bottom))" }}>
        <div className="flex items-center justify-between mb-3 px-1">
          <span className="font-display font-bold text-white">Усі розділи</span>
          <button onClick={onClose} className="grid place-items-center w-8 h-8 rounded-lg border border-white/10 text-[#94A3BD]">
            <X size={16} />
          </button>
        </div>
        <div className="grid grid-cols-2 gap-2">
          {NAV.map((item) => {
            const active = tab === item.id;
            return (
              <button key={item.id} disabled={item.soon}
                onClick={() => !item.soon && onNavigate(item.id)}
                className={`flex items-center gap-2.5 rounded-xl border px-3 py-3 text-left transition-colors ${
                  active ? "border-[#2498FF]/45 bg-[#2498FF]/10 text-white" : "border-white/[0.07] text-[#94A3BD]"
                } ${item.soon ? "opacity-40" : ""}`}>
                <item.icon size={17} strokeWidth={1.9} className={active ? "text-[#2498FF]" : ""} />
                <span className="text-[13px] font-medium truncate">{item.label}</span>
                {item.soon && <span className="ml-auto text-[9px] font-mono text-[#475569]">скоро</span>}
              </button>
            );
          })}
        </div>
        <div className="mt-3 grid grid-cols-2 gap-2">
          {NAV.flatMap((item) => (item.children || []).map((c) => (
            <button key={c.id} onClick={() => onNavigate(c.id)}
              className={`flex items-center gap-2.5 rounded-xl border px-3 py-3 text-left transition-colors ${
                tab === c.id ? "border-[#2498FF]/45 bg-[#2498FF]/10 text-white" : "border-white/[0.07] text-[#94A3BD]"
              }`}>
              <c.icon size={16} strokeWidth={1.9} className={tab === c.id ? "text-[#2498FF]" : ""} />
              <span className="text-[13px] font-medium truncate">{c.label}</span>
            </button>
          )))}
        </div>
      </div>
    </div>
  );
}
